import PropTypes from 'prop-types';
import React from 'react';
import {
  TranslationProvider,
} from '@resy/ui-kitchen';

import ConfirmCancel from '../ConfirmCancel';

import './Decline.scss';

const Decline = ({
  cancelClick,
  cancelCtaKey,
  cancelCtaText,
  confirmClick,
  confirmCtaKey,
  confirmCtaText,
}) => (
  <ConfirmCancel
    cancelClick={cancelClick}
    cancelCtaKey={cancelCtaKey}
    cancelCtaText={cancelCtaText}
    confirmButtonVariant="cancel"
    confirmClick={confirmClick}
    confirmCtaKey={confirmCtaKey}
    confirmCtaText={confirmCtaText}
  >
    <TranslationProvider translationKey="confirm_invite_decline_header">
      <h2>Cancel Your Invite?</h2>
    </TranslationProvider>
    <TranslationProvider translationKey="confirm_invite_decline_message">
      <span>You are about to leave this reservation, and may not be able to rejoin.</span>
    </TranslationProvider>
  </ConfirmCancel>
);

Decline.propTypes = {
  cancelClick: PropTypes.func,
  cancelCtaKey: PropTypes.string,
  cancelCtaText: PropTypes.string,
  confirmClick: PropTypes.func,
  confirmCtaKey: PropTypes.string,
  confirmCtaText: PropTypes.string,
};

Decline.defaultProps = {
  cancelClick: () => {},
  cancelCtaKey: 'abort_cancellation_button',
  cancelCtaText: 'Nevermind',
  confirmClick: undefined,
  confirmCtaKey: 'confirm_invite_decline_cta',
  confirmCtaText: 'Decline',
};

Decline.displayName = 'Decline';
export default Decline;
